// Import from the package root (works with CRA's classic module resolution).
// Subpath imports like '@dnai/agg-core-fe/config' need moduleResolution
// 'bundler'/'node16'; the root re-exports everything the client needs.
import { defineBranding } from '@dnai/agg-core-fe'

// Dev environment branding. Here the only real divergence from the core
// defaults is the footer's DNAi contact block — declared explicitly here
// so this file also serves as the template for future clients.
//
// To add component or page overrides later:
//   mountApp({ config: branding, overrides: { Footer: MyFooter }, extraRoutes: [...] })
export const branding = defineBranding({
    clientId: 'dev',
    product: {
        name: 'Floxgen Aggregator',
        documentTitleSuffix: 'FLOXGEN AGG',
    },
    company: {
        legalName: 'DNAi, s.r.o.',
        website: 'https://dnai.ai',
        contactEmail: 'info@dnai.ai',
        copyrightName: 'DNAI',
    },
    footer: {
        legalLinks: [
            { label: 'Privacy Policy', href: '/' },
            { label: 'Terms & Conditions', href: '/' },
        ],
    },
    theme: { palette: 'floxgen' },
    // Header logo: uses the core default (bundled Floxgen logo). To use a
    // client logo, drop it in public/ and set: assets: { headerLogo: '/logo.png' }.
    localPopulation: {
        label: 'Slovak population',
        isoCode: '703',
    },
    externalTools: {
        jupyterUrl: 'https://jupyter.agg.floxgen.dnai.ai/',
        kibanaUrl: 'https://kibana.agg.floxgen.dnai.ai/',
    },
})
